(function () {
  'use strict';

  // ── Accordion ──────────────────────────────

  // ── Category tab switching (Men / Kids) ─────────────────────────────────
  document.querySelectorAll('.jcg-cat-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = this.getAttribute('data-cat');
      // Update tabs
      document.querySelectorAll('.jcg-cat-tab').forEach(function (t) {
        t.classList.remove('jcg-cat-tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('jcg-cat-tab--active');
      this.setAttribute('aria-selected', 'true');
      // Update panels
      document.querySelectorAll('.jcg-cat-panel').forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== cat;
      });
    });
  });

  document.querySelectorAll('.jcg-accordion__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var panel    = document.getElementById(this.getAttribute('aria-controls'));
      var wrapper  = this.closest('.jcg-accordion');
      var isOpen   = !panel.hidden;

      // Close all
      document.querySelectorAll('.jcg-accordion').forEach(function (acc) {
        acc.classList.remove('jcg-accordion--open');
        acc.querySelector('.jcg-accordion__head').setAttribute('aria-expanded', 'false');
        acc.querySelector('.jcg-accordion__body').hidden = true;
      });

      // Open clicked if it was closed
      if (!isOpen) {
        wrapper.classList.add('jcg-accordion--open');
        head.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  });

  // ── Unit toggles (one per garment) ─────────
  document.querySelectorAll('.jcg-toggle__switch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var garment = this.dataset.toggle;
      var isCm    = !this.classList.contains('is-cm');

      this.classList.toggle('is-cm', isCm);

      var toggleEl = document.getElementById('jcgToggle-' + garment);
      toggleEl.querySelector('[data-unit="in"]').classList.toggle('jcg-toggle__opt--active', !isCm);
      toggleEl.querySelector('[data-unit="cm"]').classList.toggle('jcg-toggle__opt--active', isCm);

      document.querySelector('.jcg-table[data-garment="' + garment + '"][data-unit="in"]').style.display = isCm ? 'none' : '';
      document.querySelector('.jcg-table[data-garment="' + garment + '"][data-unit="cm"]').style.display = isCm ? '' : 'none';
    });
  });

  // ── Table row highlight ─────────────────────
  document.querySelectorAll('.jcg-table tbody').forEach(function (tbody) {
    tbody.addEventListener('click', function (e) {
      var row = e.target.closest('tr');
      if (!row) return;

      // Find the paired table (same garment, other unit)
      var tbl     = tbody.closest('.jcg-table');
      var garment = tbl.dataset.garment;
      var unit    = tbl.dataset.unit;
      var otherUnit = unit === 'in' ? 'cm' : 'in';
      var otherTbl  = document.querySelector('.jcg-table[data-garment="' + garment + '"][data-unit="' + otherUnit + '"]');

      var idx = Array.prototype.indexOf.call(tbody.children, row);

      // Clear all rows in both tables for this garment
      [tbl, otherTbl].forEach(function (t) {
        t.querySelectorAll('tbody tr').forEach(function (r) { r.classList.remove('is-selected'); });
      });

      // Highlight matching row in both
      row.classList.add('is-selected');
      if (otherTbl && otherTbl.querySelector('tbody').children[idx]) {
        otherTbl.querySelector('tbody').children[idx].classList.add('is-selected');
      }
    });
  });


  // ── Size Advisor ────────────────────────────
  var SIZE_DATA = {
    djellaba: {
      sizes: ['S','M','L','XL','XXL'],
      chart: {
        'S':   { hMin:60, hMax:68, wMin:100, wMax:155, chest:'26"', arm:'30.5"', length:'51"' },
        'M':   { hMin:64, hMax:70, wMin:145, wMax:185, chest:'28"', arm:'31.5"', length:'53"' },
        'L':   { hMin:67, hMax:72, wMin:175, wMax:220, chest:'30"', arm:'32.5"', length:'55"' },
        'XL':  { hMin:69, hMax:74, wMin:165, wMax:255, chest:'32"', arm:'34.5"', length:'57"' },
        'XXL': { hMin:70, hMax:76, wMin:245, wMax:999, chest:'34"', arm:'36.5"', length:'59"' }
      }
    },
    gandora: {
      sizes: ['M','L','XL'],
      chart: {
        'M':   { hMin:63, hMax:70, wMin:145, wMax:190, chest:'29"', arm:'25"',  length:'53"' },
        'L':   { hMin:67, hMax:72, wMin:180, wMax:225, chest:'30"', arm:'28"',  length:'55"' },
        'XL':  { hMin:69, hMax:74, wMin:215, wMax:999, chest:'32"', arm:'29"',  length:'57"' }
      }
    },
    caftan: {
      sizes: ['M','L','XL'],
      chart: {
        'M':   { hMin:62, hMax:69, wMin:110, wMax:165, chest:'24"', arm:'32"', length:'53"' },
        'L':   { hMin:65, hMax:71, wMin:155, wMax:200, chest:'25"', arm:'33"', length:'55"' },
        'XL':  { hMin:68, hMax:73, wMin:165, wMax:999, chest:'27"', arm:'34"', length:'57"' }
      }
    },
    shirt: {
      sizes: ['S','M','L','XL','XXL'],
      chart: {
        'S':   { hMin:60, hMax:68, wMin:100, wMax:155, chest:'26"', arm:'30.5"', length:'51"' },
        'M':   { hMin:64, hMax:70, wMin:145, wMax:185, chest:'28"', arm:'31.5"', length:'53"' },
        'L':   { hMin:67, hMax:72, wMin:175, wMax:220, chest:'30"', arm:'32.5"', length:'55"' },
        'XL':  { hMin:69, hMax:74, wMin:165, wMax:255, chest:'32"', arm:'34.5"', length:'57"' },
        'XXL': { hMin:70, hMax:76, wMin:245, wMax:999, chest:'34"', arm:'36.5"', length:'59"' }
      }
    },
    qobbiya: {
      sizes: ['S','M','L','XL','XXL'],
      chart: {
        'S':   { hMin:60, hMax:68, wMin:100, wMax:155, chest:'26"', arm:'30.5"', length:'51"' },
        'M':   { hMin:64, hMax:70, wMin:145, wMax:185, chest:'28"', arm:'31.5"', length:'53"' },
        'L':   { hMin:67, hMax:72, wMin:175, wMax:220, chest:'30"', arm:'32.5"', length:'55"' },
        'XL':  { hMin:69, hMax:74, wMin:165, wMax:255, chest:'32"', arm:'34.5"', length:'57"' },
        'XXL': { hMin:70, hMax:76, wMin:245, wMax:999, chest:'34"', arm:'36.5"', length:'59"' }
      }
    }
  };

  var TALL_THRESHOLD      = 72;
  var VERY_TALL_THRESHOLD = 76;
  var TALL_MIN_WEIGHT     = 165;

  var advisor = document.getElementById('jcSizeAdvisor');
  if (!advisor) return;

  var state = {
    garment:    advisor.dataset.defaultGarment || 'djellaba',
    heightUnit: 'ft',
    weightUnit: 'lb'
  };

  advisor.querySelectorAll('.jc-advisor__unit').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.target;
      var unit   = this.dataset.unit;
      advisor.querySelectorAll('.jc-advisor__unit[data-target="' + target + '"]')
        .forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (target === 'height') {
        state.heightUnit = unit;
        document.getElementById('jcHeight').placeholder = unit === 'cm' ? '178' : '5.10';
      } else {
        state.weightUnit = unit;
        document.getElementById('jcWeight').placeholder = unit === 'kg' ? '75' : '165';
      }
    });
  });

  advisor.querySelectorAll('.jc-advisor__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      advisor.querySelectorAll('.jc-advisor__tab').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');
      state.garment = this.dataset.garment;
      document.getElementById('jcResult').hidden = true;
      document.getElementById('jcError').hidden  = true;
    });
  });

  document.getElementById('jcCalcBtn').addEventListener('click', calculate);

  function parseFt(val) {
    var s = String(val).trim();
    if (s.indexOf('.') > -1) {
      var p = s.split('.');
      return (parseInt(p[0]) || 0) * 12 + (parseInt(p[1]) || 0);
    }
    var n = parseFloat(s);
    return (n > 12 && n < 100) ? n : n * 12;
  }
  function getHeightIn() {
    var v = parseFloat(document.getElementById('jcHeight').value);
    if (!v || v <= 0) return null;
    return state.heightUnit === 'cm' ? v / 2.54 : parseFt(v);
  }
  function getWeightLb() {
    var v = parseFloat(document.getElementById('jcWeight').value);
    if (!v || v <= 0) return null;
    return state.weightUnit === 'kg' ? v * 2.20462 : v;
  }
  function scoreSize(info, hIn, wLb) {
    var hMid = (info.hMin + info.hMax) / 2;
    var wMid = (info.wMin + info.wMax) / 2;
    var score = 0;
    if (hIn >= info.hMin && hIn <= info.hMax) { score += 50 - Math.abs(hIn - hMid) * 2; }
    else { score -= Math.min(Math.abs(hIn - info.hMin), Math.abs(hIn - info.hMax)) * 5; }
    if (wLb >= info.wMin && wLb <= info.wMax) { score += 50 - Math.abs(wLb - wMid) * 0.3; }
    else { score -= Math.min(Math.abs(wLb - info.wMin), Math.abs(wLb - info.wMax)) * 0.8; }
    return score;
  }

  function calculate() {
    var hIn   = getHeightIn();
    var wLb   = getWeightLb();
    var errEl = document.getElementById('jcError');
    var resEl = document.getElementById('jcResult');

    if (!hIn || !wLb) { errEl.hidden = false; resEl.hidden = true; return; }
    errEl.hidden = true;

    var data          = SIZE_DATA[state.garment];
    var garmentName   = state.garment.charAt(0).toUpperCase() + state.garment.slice(1);
    var isTallGarment = state.garment === 'djellaba' || state.garment === 'caftan' || state.garment === 'shirt' || state.garment === 'qobbiya';

    var scores = {};
    data.sizes.forEach(function (s) { scores[s] = scoreSize(data.chart[s], hIn, wLb); });
    var sorted = data.sizes.slice().sort(function (a, b) { return scores[b] - scores[a]; });

    var best, info, confLevel, confText, advisory;

    if (isTallGarment && hIn >= TALL_THRESHOLD && wLb < TALL_MIN_WEIGHT) {
      best = 'XL'; info = data.chart['XL'] || data.chart[data.sizes[data.sizes.length - 1]];
      confLevel = 2; confText = 'Custom recommended';
      advisory = 'You\'re tall enough for our <strong>XL</strong>' + (data.chart['XXL'] ? ' or <strong>XXL</strong>' : '') + ', but your weight is below our standard range for these sizes. We recommend a <strong>custom tailored</strong> fit. <a href="/pages/tailor-made-djellaba-guide">Explore Tailor-Made →</a>';

    } else if (isTallGarment && hIn >= VERY_TALL_THRESHOLD) {
      var topSize = data.sizes[data.sizes.length - 1];
      best = topSize; info = data.chart[topSize]; confLevel = 3; confText = topSize + ' or custom';
      advisory = 'At your height, <strong>' + topSize + '</strong> is the best standard fit. For the most precise drape, our <a href="/pages/tailor-made-djellaba-guide">Tailor-Made program</a> can size to your exact measurements.';

    } else if (isTallGarment && hIn >= TALL_THRESHOLD && wLb >= TALL_MIN_WEIGHT) {
      best = 'XL'; info = data.chart['XL'];
      var wFitXL = wLb >= info.wMin && wLb <= info.wMax;
      confLevel = wFitXL ? 5 : 3; confText = confLevel === 5 ? 'Ideal fit' : 'Good fit';
      advisory = 'At your height, <strong>XL</strong> is recommended for the best length and drape.';
      if (!wFitXL && wLb < info.wMin) { advisory += ' Your build is on the slimmer side for XL — a <a href="/pages/tailor-made-djellaba-guide">tailored fit</a> will give you the cleanest silhouette.'; }

    } else {
      best = sorted[0]; info = data.chart[best];
      var hFit = hIn >= info.hMin && hIn <= info.hMax;
      var wFit = wLb >= info.wMin && wLb <= info.wMax;
      confLevel = hFit && wFit ? 5 : (hFit || wFit) ? 3 : 2;
      confText  = confLevel === 5 ? 'Ideal fit' : confLevel === 3 ? 'Good fit' : 'Estimate only';
      if (hFit && wFit) {
        advisory = '<strong>' + best + '</strong> is your ideal size. Both height and build fall within the standard range for this ' + garmentName + '.';
      } else if (hIn < info.hMin && wLb >= info.wMin) {
        confLevel = 3; confText = 'Good fit';
        advisory = 'Your build is a great fit for <strong>' + best + '</strong>. At your height the length will run a little long — we recommend getting the hem tailored for a clean finish.';
      } else if (hIn > info.hMax) {
        advisory = '<strong>' + best + '</strong> fits your build, but your height is on the taller side — the hem may run slightly short. ' + (sorted[1] ? '<strong>' + sorted[1] + '</strong> could offer a better drape.' : '');
      } else if (wLb > info.wMax) {
        advisory = 'Your build suggests <strong>' + best + '</strong>, though for extra ease of movement consider sizing up to <strong>' + (sorted[1] || best) + '</strong>.';
      } else {
        advisory = 'Based on your proportions, <strong>' + best + '</strong> is the closest standard size. For a precision fit, explore our <a href="/pages/tailor-made-djellaba-guide">Tailor-Made program</a>.';
      }
    }

    document.getElementById('jcResultSize').textContent    = best;
    document.getElementById('jcResultGarment').textContent = garmentName;
    document.getElementById('jcChest').textContent         = info.chest;
    document.getElementById('jcArm').textContent           = info.arm;
    document.getElementById('jcLength').textContent        = info.length;
    document.getElementById('jcAdvisory').innerHTML        = advisory;
    document.getElementById('jcConfText').textContent      = confText;

    document.querySelectorAll('.jc-advisor__conf-dot').forEach(function (d, i) {
      d.classList.toggle('is-filled', i < confLevel);
    });

    var altEl = document.getElementById('jcAltPills');
    altEl.innerHTML = '';
    [sorted[1], sorted[2]].forEach(function (s, i) {
      if (!s) return;
      var pill = document.createElement('span');
      pill.className = 'jc-advisor__alt-pill' + (i === 0 ? ' is-maybe' : '');
      pill.textContent = s;
      altEl.appendChild(pill);
    });

    resEl.hidden = false;
  }

})();
// ── Measuring Guide Modal ────────────────────────────────────────────────────
(function () {
  'use strict';

  var DEFS = '<defs><marker id="ma-e" markerWidth="7" markerHeight="7" refX="5.5" refY="3.5" orient="auto"><polygon points="0,1 7,3.5 0,6" fill="#8b1f1f"/></marker><marker id="ma-s" markerWidth="7" markerHeight="7" refX="1.5" refY="3.5" orient="auto-start-reverse"><polygon points="0,1 7,3.5 0,6" fill="#8b1f1f"/></marker></defs>';
  var ARR  = ' marker-end="url(#ma-e)" marker-start="url(#ma-s)"';
  var LBL  = 'font-size="9" fill="#8b1f1f" font-family="sans-serif" font-weight="700" letter-spacing="1"';
  var FLAT = '<text x="180" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>';

  function seams(x1,y1,x2,y2,x3,y3,x4,y4) {
    return '<line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" stroke="#c8c7c0" stroke-width="0.8" stroke-dasharray="3 4"/>'
         + '<line x1="'+x3+'" y1="'+y3+'" x2="'+x4+'" y2="'+y4+'" stroke="#c8c7c0" stroke-width="0.8" stroke-dasharray="3 4"/>';
  }
  function fold(x,y1,y2) {
    return '<line x1="'+x+'" y1="'+y1+'" x2="'+x+'" y2="'+y2+'" stroke="#d0cfc8" stroke-width="1" stroke-dasharray="4 4"/>';
  }
  function arrow(x1,y1,x2,y2) {
    return '<line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" stroke="#8b1f1f" stroke-width="2"'+ARR+'/>';
  }
  function label(x,y,txt,rot) {
    var r = rot ? ' transform="rotate('+rot+')"' : '';
    return '<text x="'+x+'" y="'+y+'" '+LBL+' text-anchor="middle"'+r+'>'+txt+'</text>';
  }

  // ── Garment SVG paths ──────────────────────────────────────────────────────
  // Djellaba: full-length, hooded, wide long sleeves
  var DJ_PATH = '<path d="M 156,24 L 114,24 L 8,50 L 8,82 L 114,86 L 96,276 L 264,276 L 246,86 L 352,82 L 352,50 L 246,24 L 204,24 Q 180,52 156,24 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>';
  // Gandora: short sleeve (elbow), wider, shorter (y=240), no hood
  var GD_PATH = '<path d="M 160,24 L 114,24 L 45,55 L 45,82 L 114,86 L 98,240 L 262,240 L 246,86 L 315,82 L 315,55 L 246,24 L 200,24 Q 180,40 160,24 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>';
  // Caftan: slim body, long sleeves, no hood, full length
  var CF_PATH = '<path d="M 162,24 L 120,24 L 8,50 L 8,82 L 120,86 L 112,276 L 248,276 L 240,86 L 352,82 L 352,50 L 240,24 L 198,24 Q 180,38 162,24 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>';
  // Qobbiya: hooded, long sleeves, hip-length (y=200)
  var QB_PATH = '<path d="M 156,24 L 114,24 L 8,50 L 8,82 L 114,86 L 102,200 L 258,200 L 246,86 L 352,82 L 352,50 L 246,24 L 204,24 Q 180,52 156,24 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>';
  // Shirt/Tonika: long sleeves, no hood, shirt-length (y=195)
  var TN_PATH = '<path d="M 162,24 L 120,24 L 8,50 L 8,82 L 120,86 L 108,195 L 252,195 L 240,86 L 352,82 L 352,50 L 240,24 L 198,24 Q 180,38 162,24 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>';
  // Shorts: front view, waistband + short legs
  var SH_PATH = '<path d="M 80,40 L 280,40 L 280,235 L 195,235 L 185,82 Q 180,94 175,82 L 165,235 L 80,235 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/><rect x="80" y="40" width="200" height="22" fill="rgba(0,0,0,0.04)"/>';
  // Serwal: front view, waistband + long legs
  var SW_PATH = '<path d="M 80,40 L 280,40 L 280,276 L 195,276 L 185,82 Q 180,94 175,82 L 165,276 L 80,276 Z" fill="#f2f1ef" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/><rect x="80" y="40" width="200" height="22" fill="rgba(0,0,0,0.04)"/>';

  // ── Shared measurement arrows for standard garments (½ chest / arm / length) ──
  function standardArrows(chestX2, lengthX, lengthY2, armX2, armY2, vboxH) {
    return [
      arrow(182, 97, chestX2, 97) + label(Math.round((182+chestX2)/2), 88, '½ CHEST'),
      arrow(175, 41, armX2, armY2) + label(Math.round((175+armX2)/2 - 10), 30, 'ARM LENGTH'),
      arrow(lengthX, 28, lengthX, lengthY2) + label(lengthX+22, Math.round((28+lengthY2)/2), 'LENGTH', '90,'+(lengthX+22)+','+ Math.round((28+lengthY2)/2)),
      FLAT.replace('y="180"', 'y="'+(vboxH-3)+'"')
    ].join('');
  }

  function buildSVG(vboxW, vboxH, path, bodyEl) {
    return '<svg viewBox="0 0 '+vboxW+' '+vboxH+'" xmlns="http://www.w3.org/2000/svg">'+DEFS+path+bodyEl+'</svg>';
  }

  var MEASURE_DATA = {
    djellaba: {
      title: 'Djellaba',
      svg: buildSVG(360, 295, DJ_PATH,
        seams(114,86,96,276,246,86,264,276) + fold(180,24,276) +
        standardArrows(242, 290, 268, 14, 64, 295)),
      legend: [
        ['½ Chest', 'Garment flat · measure from the centre fold to the side seam at armpit level'],
        ['Arm Length', 'Back of neck → sleeve cuff, straight diagonal (do not follow the sleeve edge)'],
        ['Length', 'Top of shoulder seam straight down to the bottom hem along the centre']
      ]
    },
    gandora: {
      title: 'Gandora',
      svg: buildSVG(360, 255, GD_PATH,
        seams(114,86,98,240,246,86,262,240) + fold(180,24,240) +
        [
          arrow(182,96,242,96) + label(212,87,'½ CHEST'),
          arrow(177,34,50,68) + label(110,26,'ARM LENGTH'),
          arrow(278,28,278,232) + label(300,133,'LENGTH','90,300,133'),
          '<text x="180" y="252" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>'
        ].join('')),
      legend: [
        ['½ Chest', 'Garment flat · from centre fold to side seam at armpit level'],
        ['Arm Length', 'Back of neck → sleeve cuff (shorter sleeve ends at elbow)'],
        ['Length', 'Top of shoulder down to hem along the centre']
      ]
    },
    caftan: {
      title: 'Caftan',
      svg: buildSVG(360, 295, CF_PATH,
        seams(120,86,112,276,240,86,248,276) + fold(180,24,276) +
        [
          arrow(182,97,236,97) + label(209,88,'½ CHEST'),
          arrow(175,38,14,64) + label(92,28,'ARM LENGTH'),
          arrow(266,28,266,268) + label(288,152,'LENGTH','90,288,152'),
          '<text x="180" y="292" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>'
        ].join('')),
      legend: [
        ['½ Chest', 'Garment flat · from centre fold to side seam at armpit level (slimmer than djellaba)'],
        ['Arm Length', 'Back of neck → sleeve cuff, straight diagonal'],
        ['Length', 'Shoulder seam straight down to hem — caftan runs full length']
      ]
    },
    qobbiya: {
      title: 'Qobbiya',
      svg: buildSVG(360, 215, QB_PATH,
        seams(114,86,102,200,246,86,258,200) + fold(180,24,200) +
        [
          arrow(182,97,242,97) + label(212,88,'½ CHEST'),
          arrow(175,41,14,64) + label(92,31,'ARM LENGTH'),
          arrow(278,28,278,193) + label(300,114,'LENGTH','90,300,114'),
          '<text x="180" y="212" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>'
        ].join('')),
      legend: [
        ['½ Chest', 'Garment flat · centre fold to side seam at armpit level'],
        ['Arm Length', 'Back of neck → sleeve cuff (long sleeve, like djellaba)'],
        ['Length', 'Shoulder seam to hem — qobbiya is hip/shirt length']
      ]
    },
    tonika: {
      title: 'Shirt (Tonika)',
      svg: buildSVG(360, 210, TN_PATH,
        seams(120,86,108,195,240,86,252,195) + fold(180,24,195) +
        [
          arrow(182,97,237,97) + label(210,88,'½ CHEST'),
          arrow(175,38,14,64) + label(92,28,'ARM LENGTH'),
          arrow(266,28,266,188) + label(288,112,'LENGTH','90,288,112'),
          '<text x="180" y="207" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>'
        ].join('')),
      legend: [
        ['½ Chest', 'Garment flat · centre fold to side seam at armpit level'],
        ['Arm Length', 'Back of neck → sleeve cuff (full long sleeve)'],
        ['Length', 'Shoulder seam down to hem — shirt length, not full robe']
      ]
    },
    shorts: {
      title: 'Shorts',
      svg: buildSVG(360, 265, SH_PATH,
        [
          arrow(84,56,276,56) + label(180,48,'WAIST'),
          arrow(60,44,60,232) + label(38,142,'LENGTH','−90,38,142'),
          '<text x="180" y="260" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>'
        ].join('')),
      legend: [
        ['Waist', 'Full circumference around the waist — range shown is the stretch range'],
        ['Length', 'From the top of the waistband straight down the outer leg to the hem (outseam)']
      ]
    },
    serwal: {
      title: 'Serwal (Pants)',
      svg: buildSVG(360, 295, SW_PATH,
        [
          arrow(84,56,276,56) + label(180,48,'WAIST'),
          arrow(60,44,60,272) + label(38,162,'LENGTH','−90,38,162'),
          '<text x="180" y="292" font-size="8" fill="#b0afaa" text-anchor="middle" font-family="sans-serif" letter-spacing="1.5">GARMENT LAID FLAT</text>'
        ].join('')),
      legend: [
        ['Waist', 'Full circumference around the waist — range shown is the stretch range'],
        ['Length', 'From the top of the waistband straight down the outer leg to the hem']
      ]
    }
  };

  var modal   = document.getElementById('jcgMeasureModal');
  if (!modal) return;
  var overlay = modal.querySelector('.jcg-modal__overlay');
  var figEl   = document.getElementById('jcgModalFigure');
  var legEl   = document.getElementById('jcgModalLegend');
  var tagEl   = document.getElementById('jcgModalTag');
  var closeBtn = modal.querySelector('.jcg-modal__close');

  function openModal(garmentKey) {
    var d = MEASURE_DATA[garmentKey];
    if (!d) return;
    tagEl.textContent  = d.title;
    figEl.innerHTML    = d.svg;
    legEl.innerHTML    = d.legend.map(function(item) {
      return '<li><strong>'+item[0]+'</strong><span>'+item[1]+'</span></li>';
    }).join('');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.jcg-measure-btn').forEach(function(btn) {
    btn.addEventListener('click', function() { openModal(this.dataset.garment); });
  });
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

})();
